import { render } from "./BaseCard.vue?vue&type=template&id=671dcf67&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=671dcf67&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\VUE_Tuts\\cybershyft\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671dcf67"]])

export default __exports__